import { CommentThreadFragment } from "generated-graphql/graphql";

/**
 * Shared comment rules for the comment surfaces (`CommentThread`, the stepper's
 * `SubmissionCommentsPanel`), so they cannot drift.
 */

/**
 * Whether the current user may delete a comment: only their own non-system
 * comments, and never a reviewer-rejection reason ("Rejected by reviewer: …"
 * — written by the backend on rejection), which is part of the review audit
 * trail.
 */
export function isCommentDeletableByUser(
  comment: Pick<CommentThreadFragment, "comment" | "isSystemMessage"> & {
    user?: { id: string } | null;
  },
  currentUserId: string | undefined
): boolean {
  return Boolean(
    currentUserId &&
    comment.user?.id === currentUserId &&
    !comment.isSystemMessage &&
    !comment.comment?.startsWith("Rejected by reviewer:")
  );
}

/** Display name for a comment's author, falling back to the audit column. */
export function getCommentAuthor(
  comment: Pick<CommentThreadFragment, "updatedBy"> & {
    user?: { email?: string | null } | null;
  }
): string {
  return comment.user?.email ?? comment.updatedBy ?? "Someone";
}
